const Forms = () => {
	const hubspotForm = document.querySelectorAll(
		'.hbspt-form form.hs-custom-style'
	);

	//Remove hubspot's styling from forms
	if (hubspotForm) {
		hubspotForm.forEach(function (form) {
			form.classList.remove('hs-custom-style');
		});
	}

	function updateOptions() {
		const wpesOptions = document.querySelectorAll('#wpes-datalist option');
		if (wpesOptions) {
			wpesOptions.forEach((option) => {
				option.textContent = option.textContent.replace('tc_', '');
			});
		}
	}

	// Initially update the options if available
	updateOptions();

	function delayedUpdate() {
		setTimeout(updateOptions, 1000); // Wait 1 second before updating options
	}

	// Attach focus and input events to all search type inputs
	const searchInputs = document.querySelectorAll('input[type="search"]');
	searchInputs.forEach((input) => {
		input.addEventListener('focus', updateOptions);
		input.addEventListener('input', updateOptions);

		input.addEventListener('focus', delayedUpdate);
		input.addEventListener('input', delayedUpdate);

		let isDatalistSelection = false;
		const formElement = input.closest('form');

		input.addEventListener('input', function () {
			if (isDatalistSelection) {
				isDatalistSelection = false;
				input.value = input.value.trim();
				formElement.submit();
			}
		});

		input.addEventListener('keydown', function () {
			isDatalistSelection = false; // Reset the flag on key press
		});

		input.addEventListener('change', function (event) {
			const options = document.querySelectorAll(
				`#${input.getAttribute('list')} option`
			);
			const value = event.target.value;
			isDatalistSelection = Array.from(options).some(
				(option) => option.value === value
			);

			if (isDatalistSelection) {
				input.dispatchEvent(new Event('input'));
			}
		});

		input.addEventListener('keydown', function (event) {
			if (event.key === 'Enter') {
				input.value = input.value.trim();
			}
		});
	});
};

export default Forms;
